// extracted by mini-css-extract-plugin
export default {"container":"LoginPage_container__I-yAJ","mobileContainer":"LoginPage_mobileContainer__0P7yS","logo":"LoginPage_logo__o8eg5","toast":"LoginPage_toast__Ud3Jq"};